const axios = require('axios');
const qs    = require('querystring');

export const GetUsers = () => {
    return (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        return firestore.collection("users").onSnapshot((snapshot) => {
            let users = [];
            snapshot.forEach(doc => {
                let data = doc.data();
                data.id = doc.id;
                users.push(data);
            });          
            dispatch({ type: 'GET_USERS', users: users });
        });
    }
}

export const DeleteUser = (uid) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        if(typeof uid === "string") {
            await firestore.collection("users").doc(uid).delete();
        }
        alert('User has been deleted');
    }
};

export const UpdateAccount = (email) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        firebase.auth().currentUser.updateEmail(email).then(function() {
            alert("Email has been updated!");
        }).catch(function(error) {
            // console.log(error);
            alert(error.message);
        });
          
    }
}

export const UpdateUser = (uid, formData) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        if(typeof uid === "string") {

            let gates_snapshot = await firestore.collection("users").doc(uid).collection("gates").get();

            gates_snapshot.forEach(gate => {
                firestore.collection("gates").doc(gate.id).collection("users").doc(uid).set({name: formData.name, isAdmin: formData.isAdmin, phone: formData.phone}, {merge: true});
            });

            await firestore.collection("users").doc(uid).set(formData, {merge: true});
            
        }
        alert('User has been Updated');
    }
};

export const SuperAdmin = (uid, value) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        firebase.auth().currentUser.getIdToken(true).then( async idToken => {
            let post_url = `https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/superAdmin/${uid}`;
            let result = await axios.post(
                post_url, 
                { idToken: idToken, value: value }, 
            );
            // console.log(result);
        }).catch( e  => console.log( e ));
    }
}

export const ClearUsers = () => {
    return async (dispatch, getState, {getFirebase}) => {
        dispatch({ type: 'CLEAR_USERS' });
    }
};

export const GetUserDetails = (uid) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();

        let claims = await fetch(`https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/isAdmin/${uid}`)
        .then(result => result.json())

        return firestore.collection("users").doc(uid).onSnapshot(async (snapshot) => {
            if( snapshot.exists ) {
                let user = snapshot.data();
                let gates = [];
                if( user.gates ) {
                    let promises = user.gates.map( async id => await firestore.collection("gates").doc(id).collection("private").doc("data").get()
                        .then( snapshot => {
                            if( snapshot.exists ) {
                                let gate = snapshot.data();
                                gate.id = id;
                                gates.push({...gate});
                            }
                        }))
                    await Promise.all(promises);
                }
                user.isAdmin    = claims.isAdmin;
                // user.phone      = claims.phone;
                user.gates      = gates;
                dispatch({ type: 'GET_USER_DETAILS', user: user });
            } else {
                dispatch({ type: 'GET_USER_DETAILS', user: {} });
            }
        });

    }
}

const eventLog = async ( gateID, summary ) => {
    let post_url = `https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/event/${gateID}`;
    let result = await axios.post(
        post_url, 
        { summary: `${summary} MAX Tech Support` }, 
    );
}
